// teams

const mutations = {
	getTeams(state, objects) {
  		state.teams = objects;
	},
	getTeam(state, object) {
  		state.team = object;
	},
	resetTeam(state) {
  		state.team = {};
	},

};

export default mutations;